export enum TestState {
  Uninitialized = "uninitialized",
  Success = "success",
  Fail = "fail",
}

export const API_RESULT_TIMEOUT = {
  CONNECTION_TEST: 6000,
  DATASTORE: 2000,
};
